"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _UpdateFormSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/form/stagedObjects/UpdateFormSettings"));

var _default = (0, _redux.combineReducers)({
  updateFormSettings: _UpdateFormSettings.default.getReducer()
});

exports.default = _default;
module.exports = exports.default;